import React, { useState } from "react"
import { Button, Card, CardBody, Collapse } from "reactstrap"
import { useNavigate } from "react-router-dom"
import CustomHeaderTitle from "components/Common/CustomHeaderTitle"
import GeneralTables from "components/Common/GeneralTable"
import ActionColumns from "components/Common/GeneralTable/ActionColumns"
import CSAlert from "components/Alert/ConfirmationAlert"
import { result } from "lodash"
import SAlert from "components/Alert"
import ProviderInFilter from "./ProvinceInFilter"
import ProvinceInFilter from "./ProvinceInFilter"
import ProvinceInTotalBox from "./ProvinceInTotalBox"
import TransferModal from "./TransferModal"
import ReturnModal from "./ReturnModal"

const ProvinceInListComponent = ({
  data,
  error,
  loading,
  onPageClick,
  onSearch,
  onChangeRowNumber,
  onChangeOrdering,
  onAdvancedSearchSubmit,
  permissions,
  onClickDetail,
  onExportBtnClick,
  exportStatus,
  onProcessDistribution,
  processDistributionStatus,
  distributionMode,
  onDistributionModeChange,
}) => {
  const navigate = useNavigate()
  const [ids, setIds] = useState([])
  const [filterOpen, setFilterOpen] = useState(false)
  const [transferModal, setTransferModal] = useState(false)
  const [returnModal, setReturnModal] = useState(false)
  const [selectedReceipt, setSelectedReceipt] = useState(null)

  // Store record in their state when a checkbox is clicked
  const onCheckboxClick = (e, id) => {
    const check = ids.includes(id)
    console.log(id)

    if (check) {
      const updated = ids.filter(myId => myId !== id)
      setIds(updated)
    } else {
      setIds(prev => {
        return [...prev, id]
      })
    }
  }

  // Handle parent checkbox status change to select/deselect all items
  const onParentCheckChange = status => {
    if (status) {
      // Select all items on the current page
      // Backend already filtered to show only items with in_qty > 0 when in distribution mode
      const all = data?.data.map(dt => dt.id)
      setIds(all)
    } else {
      setIds([])
    }
  }

  // Callback function to toggle the advanced search filter visibility when the button is clicked
  const onAdvancedSearchHandler = result => {
    setFilterOpen(result)
  }

  // Handle transfer button click
  const handleTransferClick = receipt => {
    setSelectedReceipt(receipt)
    setTransferModal(true)
  }

  const handleReturnClick = receipt => {
    setSelectedReceipt(receipt)
    setReturnModal(true)
  }

  const getLockMessage = receipt => {
    if (receipt?.lock_reason === "pending return") {
      return "Locked due to pending return request"
    }
    return "Locked due to pending transfer"
  }

  // Handle Start Process Distribution button click
  const handleStartDistributionMode = () => {
    onDistributionModeChange(!distributionMode)
    setIds([]) // Clear any previous selections
  }

  // Handle Process Distribution button click
  const handleProcessDistribution = async () => {
    if (ids.length === 0) {
      await SAlert({
        title: "No records selected",
        text: "Please select at least one receipt to process distribution",
        icon: "warning",
      })
      return
    }

    const results = await CSAlert({
      title: "Are you sure?",
      text: `Process distribution for ${ids.length} selected receipt(s)?`,
    })

    if (results.isConfirmed) {
      onProcessDistribution(ids)
      setIds([]) // Clear selection after processing
      onDistributionModeChange(false) // Exit distribution mode
    }
  }

  return (
    <React.Fragment>
      <Card>
        <CardBody>
          {/*
            CustomHeaderTitle Component Props:
            
            - loading: Boolean flag to display loading state
            - title: String to display as the header title
            - rowCount: Boolean to show/hide the row number selector
            - lgColumn: Number to control the width of columns based on layout needs
            - onChangeRowNumber: Callback function to handle row number selection change
            - orderingList: Boolean to show/hide ordering dropdown
            - onChangeOrdering: Callback function triggered when the ordering option is changed
            - searchBox: Boolean to show/hide search input box
            - onSearchHandler: Function called on key up in the search box
            - rightBtn: Boolean to show/hide right-side button (for example, a back button)
            - rightBtnTitle: String for setting the right button's label
            - rightBtnRoute: Route for the right button's navigation
            - exportBtn: Boolean to show/hide export button
            - onExportBtnClick: Callback for when the export button is clicked
            - exportBtnLoading: Boolean flag to show loading state during export functionality
            - advnacedSearchBtn: Boolean to show/hide advanced search button
            - advnacedSearchBtnTitle: String to display the advanced search button label
            - onAdvancedSearch: Callback function when the advanced search button is clicked (used to toggle collapse)
            - orderingOptions: Array of options to populate the ordering dropdown (value and name pair)
          */}
          <CustomHeaderTitle
            loading={loading}
            title={"List"}
            rowCount={true}
            onChangeRowNumber={onChangeRowNumber}
            orderingList={true}
            onChangeOrdering={onChangeOrdering}
            searchBox={true}
            onSearchHandler={onSearch}
            advnacedSearchBtn={true}
            advnacedSearchBtnTitle={"Filter"}
            onAdvancedSearch={onAdvancedSearchHandler}
            orderingOptions={[
              { value: "id", name: "ID" },
              { value: "expire_date", name: "Exipre Date" },
              { value: "date", name: "Submission Date" },
            ]}
            exportBtn={true}
            onExportBtnClick={onExportBtnClick}
            exportBtnLoading={exportStatus?.loading}
          />

          {/* Start Process Distribution Button */}
          <div className="mb-3">
            <Button
              color={distributionMode ? "secondary" : "success"}
              onClick={handleStartDistributionMode}
              outline={!distributionMode}
            >
              {distributionMode ? (
                <>
                  <i className="bx bx-x font-size-16 align-middle me-2"></i>
                  Cancel Distribution Mode
                </>
              ) : (
                <>
                  <i className="bx bx-list-check font-size-16 align-middle me-2"></i>
                  Start Process Distribution
                </>
              )}
            </Button>
            {distributionMode && (
              <span className="ms-2 text-muted">
                <i className="bx bx-info-circle"></i> Showing only records with
                available quantity
              </span>
            )}
          </div>

          {/* Process Distribution Button */}
          {distributionMode && ids.length > 0 && (
            <div className="mb-3">
              <Button
                color="primary"
                onClick={handleProcessDistribution}
                disabled={processDistributionStatus?.loading}
              >
                {processDistributionStatus?.loading ? (
                  <>
                    <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
                    Processing...
                  </>
                ) : (
                  <>
                    <i className="bx bx-check-double font-size-16 align-middle me-2"></i>
                    Process Distribution ({ids.length})
                  </>
                )}
              </Button>
            </div>
          )}
          {/* Province Receip Total box  */}
          <ProvinceInTotalBox totals={data?.totals} />
          <Collapse isOpen={filterOpen}>
            {/* Province Receipt Filter  */}
            <ProvinceInFilter
              loading={loading}
              onAdvancedSearchSubmit={onAdvancedSearchSubmit}
            />
          </Collapse>

          {/*
            GeneralTables Component Props:

            - data: Array containing the data to be displayed in the table
            - loading: Boolean indicating the loading state of the table
            - parentCheckbox: Boolean to determine if a parent checkbox is included in the table
            - headers: Array of strings representing the column headers for the table
            - pagination: Object containing pagination metadata and a callback function:
                - meta: Object for pagination details (e.g., page number, total items)
                - onPageClick: Callback function to handle page number changes
            - renderItem: Function to render each row/item in the table using the provided data
          */}
          <GeneralTables
            data={data?.data}
            loading={loading}
            parentCheckbox={distributionMode}
            onParentCheckChange={onParentCheckChange}
            headers={[
              "SN",
              "PROJECT",
              "PROVIDER",
              "PROVINCE",
              "HEALTH FACILITY",
              "UNFPA ITEM ID",
              "IP- ITEM DESCRIPTION",
              "UNFPA UNIT OF MEASURE (UOM))",
              "IP UNIT UOM",
              "BATCH NUMBER",
              "EXPIRE DATE",
              "QUANTITY",
              "RECEIPT DATE",
              "ACTION",
            ]}
            pagination={{ meta: data?.meta, onPageClick: onPageClick }}
            renderItem={(pIn, index) => {
              const canSelect = pIn.in_qty > 0
              return (
                <tr
                  key={index}
                  className={
                    !canSelect && distributionMode ? "table-secondary" : ""
                  }
                >
                  <th scope="row">
                    {distributionMode ? (
                      <div className="form-check form-checkbox-outline form-check-primary mb-3">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id={`checkbox-${pIn.id}`}
                          checked={ids.includes(pIn.id)}
                          onChange={e => onCheckboxClick(e, pIn.id)}
                          disabled={!canSelect}
                        />
                        <label
                          className="form-check-label"
                          htmlFor={`checkbox-${pIn.id}`}
                        >
                          {data?.meta?.from + index}
                        </label>
                      </div>
                    ) : (
                      <span className="ms-3">{data?.meta?.from + index}</span>
                    )}
                  </th>
                  <td>{pIn?.project?.name}</td>
                  <td>{pIn?.provider?.title}</td>
                  <td>{pIn?.province?.province}</td>
                  <td>{pIn?.facility?.facility_name}</td>
                  <td>{pIn?.item?.unfp_item_name}</td>
                  <td>{pIn?.item?.ip_item_description}</td>
                  <td>
                    {pIn?.item.uom} &nbsp;
                    {pIn?.item.unfpa_uom_quantity > 1 &&
                      pIn?.item.unfpa_uom_quantity}
                  </td>
                  <td>
                    {pIn?.item.ip_unit_umo} &nbsp;
                    {pIn?.item.ip_uom_quantity > 1 && pIn?.item.ip_uom_quantity}
                  </td>
                  <td>{pIn.batch_number}</td>
                  <td>{pIn.expire_date}</td>
                  <td>{pIn.first_in_qty}</td>
                  <td>{pIn.date}</td>
                  <td>
                    <div className="d-flex gap-1">
                      {pIn.in_qty > 0 && !pIn.locked && (
                        <>
                          <Button
                            size="sm"
                            color="info"
                            onClick={() => handleTransferClick(pIn)}
                            className="me-1"
                          >
                            Transfer
                          </Button>
                          <Button
                            size="sm"
                            color="warning"
                            onClick={() => handleReturnClick(pIn)}
                            className="me-1"
                          >
                            Re-allocation
                          </Button>
                        </>
                      )}
                      <ActionColumns
                        enableDetail={true}
                        data={pIn}
                        onClickDetail={onClickDetail}
                        disabled={pIn.locked}
                        disabledMessage={getLockMessage(pIn)}
                      />
                    </div>
                  </td>
                </tr>
              )
            }}
          />
        </CardBody>
      </Card>

      {/* Transfer Modal */}
      <TransferModal
        isOpen={transferModal}
        toggle={() => {
          setTransferModal(false)
          setSelectedReceipt(null)
        }}
        receiptData={selectedReceipt}
      />

      <ReturnModal
        isOpen={returnModal}
        toggle={() => {
          setReturnModal(false)
          setSelectedReceipt(null)
        }}
        receiptData={selectedReceipt}
      />
    </React.Fragment>
  )
}

export default ProvinceInListComponent
